export default {"src":"/_next/static/media/Left.8f04ae5b.svg","height":54,"width":29,"blurWidth":0,"blurHeight":0};